<template>
  <!-- 历史浏览记录模块 -->
  <div class="br-wrap" v-show="isShow()">
    <!--蒙版-->
    <div
      class="PageOverlay"
      :class="active ? 'show-Overlay' : ''"
      @click="active = false"
    ></div>
    <!--主体 :class="{ 'show-pc-content': active }"-->
    <div
      class="br-pop"
      v-show="has_data"
      v-clickoutside="handleClose"
      :class="[
        active ? 'show-pc-content' : '',
        browsing_record.length
          ? active
            ? 'show-pc-content-hasdata'
            : ''
          : active
          ? 'show-pc-content-notdata'
          : '',
        browsing_record.length >= 4 ? 'pc-content' : '',
      ]"
    >
      <!--展开关闭按钮-->
      <v-btn
        :click="bth_click"
        :active="active"
        :title="button_title"
        :button="button_color"
      ></v-btn>
      <!--展开面板-->
      <div :class="browsing_record.length ? 'pc-br-content' : 'nodata'">
        <!--自定义左右移动按钮，商品卡片模块插入插槽-->
        <v-custom-swiper
          :total_num="browsing_record.length"
          :page_num="4"
          v-if="browsing_record.length"
        >
          <div
            class="content-wrap"
            :class="
              browsing_record.length < 4
                ? browsing_record.length < 2
                  ? 'small-item-count'
                  : ''
                : ''
            "
          >
            <div
              class="br-item"
              v-for="(item, index) in browsing_record"
              :key="item.ID + 'pc_browsing' + index"
            >
              <v-add-card-height
                v-if="theme !== 'athena'"
                :product="item"
                :show_name="display_info.product_name"
                :show_add_btn="display_info.add_cart_button"
                :show_start="display_info.comment_star"
                :show_product_price="display_info.product_price"
                :add_cart="add_cart"
                :show_currency_selector="show_currency_selector"
                :isPC="isPC"
                :show_tag="true"
                select_style="item"
                :show_discount_label="!!browsing_record_config.discount_label"
                :discount_label_color="discount_label_color"
              ></v-add-card-height>
              <v-product-card
                v-else
                :productDetail="item"
                :disable_select="true"
                :show_name="display_info.product_name"
                :show_star="display_info.comment_star"
                :show_product_price="display_info.product_price"
                :show_currency_selector="show_currency_selector"
                :cart_type="cart_type"
                :theme="theme"
                card_animate="vogue-am"
                text_align="left"
                :custom_button="
                  item.custom_button && item.custom_button.custom_button
                "
                model="is_card"
                :show_add_card_btn="false"
                addType="browsingRecord"
                :show_discount_tag="!!browsing_record_config.discount_label"
                :discount_label_color="discount_label_color"
                combination_position="record"
              ></v-product-card>
            </div>
          </div>
        </v-custom-swiper>
        <!--无数据时的展示-->
        <div v-else>
          <span>{{ $t("browsingRecord.no_data") }}</span>
        </div>
      </div>
    </div>
    <!-- <div class="mb-br-content" :class="{ 'show-mb-content': active }">
      <v-customSwiper :total_num="browsing_record.length" :page_num="2">
        <div class="content-wrap">
          <div
            class="br-item"
            v-for="(item, index) in browsing_record"
            :key="item.ID + 'mb_browsing' + index"
          >
            <v-addCardHeight
              :product="item"
              :show_name="display_info.product_name"
              :show_add_btn="display_info.add_cart_button"
              :show_start="display_info.comment_star"
              :show_product_price="display_info.product_price"
              :add_cart="add_cart"
            ></v-addCardHeight>
          </div>
        </div>
      </v-customSwiper>
    </div> -->
  </div>
</template>
<script>
import vBtn from "./brPopBtn.vue";
import vAddCardHeight from "../../common/addCardHight.vue";
// import API from "../../../API";
import vCustomSwiper from "../../common/customSwiper.vue";
import googleAnalysis from "@/js/lib/ga";
import mixClose from "../../../mixins/mixClose";
export default {
  props: [
    "theme",
    "cart_type",
    "browsing_record_config",
    "product_id",
    "show_currency_selector",
    "combination_config",
    "discount_label_color",
  ],
  data() {
    return {
      browsing_record: [],
      browsing_record_ids: [],
      active: false,
      has_data: false,
      button_title: "",
      button_color: {},
      display_info: {},
      isPC: !navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ),
    };
  },
  mixins: [mixClose],
  methods: {
    isShow() {
      return !(window.location.pathname == "/cart" && !this.isPC);
    },
    async add_cart(payload, variant) {
      try {
        this.disabled = true;
        this.$store.dispatch("change_button_disabled", true);
        let res = await this.$axios.post(API.addcart, {...payload,addType:"browsingRecord"});
        if (window.fbq) {
          let content_category = [];
          if (variant.categories && variant.categories.length) {
            variant.categories.forEach((item) => {
              content_category.push(item.name);
            });
          }
          this.send_fb_event("AddToCart", {
            content_type: "product_group",
            content_ids: [payload.product_id],
            value: variant.price,
            num_items: payload.quantity,
            content_name: variant.title,
            currency:  window.checkoutcurrency||"USD",
            content_category,
          });
        }
        if (window.ttq){
            window.send_ttp_event("AddToCart",{
                content_id: [payload.product_id], 
                quantity: payload.quantity,
                value: variant.price, 
                currency: window.checkoutcurrency||"USD"
            })
        }
        if (window._learnq) {
          this.klaviyo_addtocart(variant, payload);
        }
        // if (window.gtag) {
        //   window.gtag("event", "add_to_cart");
        // }
        // 添加到购物车
        googleAnalysis.event(googleAnalysis.gaAction.add, {});

        this.$store.dispatch("change_news_cart", res.data);
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
        this.active = false;
        if (
          (this.theme == "Brooklyn" || this.theme == "showtime") &&
          this.cart_type == "drawer"
        ) {
          if (this.theme == "Brooklyn") {
            this.$store.dispatch("change_cart_type", true);
          }
          if (this.theme == "showtime") {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            this.$("#collapseExample").collapse("show");
          }
        } else if (
          (this.theme == "venue" || this.theme == "showtime") &&
          this.cart_type == "popup"
        ) {
          this.$("#modalCart").modal("show");
        } else if (
          this.theme == "vogue" &&
          (this.cart_type == "drawer" || this.cart_type == "popup")
        ) {
          this.showInlineCart();
        } else {
          window.open("/cart", "_self");
        }
      } catch (error) {
        this.disabled = false;
        this.$store.dispatch("change_button_disabled", false);
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else {
          this.$message.error(error.response.data.message);
        }
      }
    },
    bth_click() {
      this.active = !this.active;
    },
    handleClose() {
      this.active = false;
    },
  },
  mounted() {
    let { content } = this.browsing_record_config;
    if (content && content.background_color) {
      this.$el.style.setProperty(
        "--content-background_color",
        content.background_color
      );
    } else {
      this.$el.style.setProperty("--content-background_color", "#ffffff");
    }

    try {
      let payload = this.product_id
        ? {
            product_id: this.product_id,
          }
        : {};
      this.$axios
        .get("/api/store/browsing-record/records", {
          params: payload,
        })
        .then((res) => {
          this.browsing_record = res.data.data;
          this.has_data = true;
        })
        .catch((err) => {
        });
    } catch (error) {}
  },
  watch: {
    browsing_record_config: {
      handler(newV) {
        let { title, button, display_info } = newV;
        this.button_title = title;
        this.button_color = button ? button : {};
        this.display_info = display_info ? display_info : {};
      },
      immediate: true,
      deep: true,
    },
    browsing_record: {
      handler(newV) {
        let val = 0;
        let phoneval = "0px";
        let length = newV.length;
        this.browsing_record_ids=[];
        if (length) {
          this.browsing_record_ids = newV.map((item) => {
            return item.ID;
          });
          if(this.combination_config){
            this.$store.dispatch('get_combination_list',{
              'filter[product_ids]' : this.browsing_record_ids.join(','),
              combination_position: "record"
            })
          }
          val = 19 * (length > 4 ? 4 : length) + "%";
          phoneval =
            length > 2
              ? 100 - 375 / 44 + "%"
              : 156 * (length > 2 ? 2 : length) + 10 + "px";
        } else {
          val = 1192 + "px";
        }
        this.$el.style.setProperty("--content-width", val);
        this.$el.style.setProperty("--phone-content-width", phoneval);
      },
      immediate: false,
      deep: true,
    },
  },
  components: {
    vBtn,
    vAddCardHeight,
    vCustomSwiper,
  },
};
</script>
<style scoped lang='scss'>
.br-wrap {
  --content-width: 0%;
  --phone-content-width: 0 px;
  .br-pop {
    display: flex;
    position: fixed;
    // 在购物车弹窗之下（200）
    // 菜单栏悬浮，在菜单栏之上（198）
    z-index: 199;
    top: 30%;
    align-items: flex-start;
    left: 100%;
    // right: calc(0px - var(--content-width));
    width: calc(var(--content-width) + 32px);
    max-width: 1232px;
    &::v-deep {
      .br-pop-btn {
        height: 32px;
        flex-grow: 0;
        border-radius: 0;
      }
    }
    .pc-br-content {
      background: var(--content-background_color);
      flex: 1;
      text-align: center;
      box-sizing: border-box;
      padding: 20px 0 20px 20px;
      max-width: calc(100% - 32px);
      box-shadow: 0px 2px 16px 0px #dadada;
      &::v-deep {
        &>.custom-swiper-wrap>.navigation {
          .custom-swiper-next,
          .custom-swiper-prev {
            width: 48px;
            height: 48px;
            top: calc(var(--content-width) / 4 - 20px / 2 + 30px);
          }
          .custom-swiper-prev {
            left: 2%;
          }
          .custom-swiper-next {
            right: calc(2% + 20px);
          }
        }
        .custom-swiper {
          overflow-x: clip !important;
        }
      }
      .content-wrap {
        display: flex;
        .br-item {
          padding-right: 20px;
          flex: 1;
          min-width: 25%;
          flex-shrink: 0;
          &::v-deep {
            .add-card-height {
              position: relative;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              height: 100%;
              .item_price {
                .selectpricewrap {
                  div {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                  }
                  div:hover {
                    display: inline-block;
                    overflow: visible;
                    span {
                      span {
                        cursor: pointer !important;
                      }
                    }
                  }
                }
              }
              .discount_tag{
                //pad屏幕
                @media screen and (min-width: 768px) and (max-width: 991px){
                  &__text {
                    font-size: 12px;
                  }
                }
                //中等PC屏幕
                @media screen and (min-width: 992px) and (max-width: 1199px){
                  &__text {
                    font-size: 14px;
                  }
                }
              }
            }
            .item_addbtn:hover ~ .item_attribute,
            .item_attribute:hover {
              display: block;
            }
            .item_attribute {
              display: none;
              box-shadow: -4px -2px 8px -4px #dddddd, 4px -2px 8px -4px #dddddd;
              // height: 93px;
              position: absolute;
              bottom: 38px;
              background-color: #fff;
              padding: 12px;
              // border: 1px solid #DDDDDD;
              // opacity: 0.8;
              height: auto;
              padding: 12px;
              .all_attribute {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                margin-bottom: 8px;
                .attrsbute_name {
                  height: 20px;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #222222;
                  line-height: 20px;
                }
                .attrsbute_select {
                  width: 100%;
                  position: relative;
                  select {
                    appearance: none;
                    -moz-appearance: none;
                    -webkit-appearance: none;
                    width: 100%;
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    text-align: left;
                    -moz-text-align-last: left;
                    text-align-last: left;
                    background: #ffffff;
                    border: 1px solid #dddddd;
                    font-size: 14px;
                    appearance: none;
                    -moz-appearance: none;
                    -webkit-appearance: none;
                    padding-right: 20px;
                    padding-left: 8px;
                    border-radius: 4px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #222222;
                    line-height: 20px;
                    height: 40px;
                  }
                }
              }
              .all_attribute:last-child {
                margin-bottom: 0 !important;
              }
            }
          }
          &::v-deep {
            .athena-product-card {
              box-shadow: unset;
              margin-bottom: 0;
              .product_item {
                margin-bottom: 0 !important;
              }
            }
          }
        }
      }
    }
    .nodata {
      background: var(--content-background_color);
      width: 100%;
      box-shadow: 0px 2px 16px 0px #dadada;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 490px;
        span {
          text-align: center;
        }
      }
    }
  }
  .show-pc-content-notdata {
    left: auto;
    right:-32px;
    width: 100% !important;
  }
  .show-pc-content-hasdata {
    left: auto;
    right: -32px;
    width: calc(var(--content-width) + 32px);
    // width: auto;
  }
}

@media screen and(max-width:768px) {
  #app .br-wrap {
    .show-Overlay {
      background-color: #000;
      opacity: 0.5;
      // 背景遮罩
      z-index: 1021;
      visibility: visible;
    }
    // 展开内容
    .show-pc-content {
      &.br-pop {
        // 理论最高层
        // 在背景遮罩之上(1021)
        z-index: 1022;
      }
    }
    .br-pop {
      // 未展开内容
      // 在购物车抽屉和弹窗之下
      z-index: 199;
      width: 100%;
      &::v-deep {
        .br-pop-btn {
          //padding: 2px 6px !important;
          font-size: 14px !important;
          height: 32px !important;
          .br-btn-name {
            line-height: 32px !important;
          }
        }
      }
      .nodata {
        width: calc(100% - 32px);
        height: 280px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0px;
        padding: 0 50px;
        justify-content: center;
        display: flex;
        flex-direction: column;
        div {
          height: auto;
        }
      }
      .pc-br-content {
        width: calc(100% - 32px);
        padding: 10px 0 10px 10px;
        box-shadow: none !important;
        &::v-deep {
          overflow: hidden;
          .navigation {
            display: none;
          }
          .content-wrap::-webkit-scrollbar {
            display: none;
          }
          .content-wrap {
            overflow-x: auto;
            .br-item {
              flex: none !important;
              flex-basis: 156px !important;
              padding-right: 10px !important;
              &::v-deep {
                .item_attribute {
                  display: none;
                }
                .item_addbtn:hover ~ .item_attribute,
                .item_attribute:hover {
                  display: none !important;
                }
              }
            }
          }
          .content-wrap::-webkit-scrollbar {
            display: none;
          }
        }
      }
    }
    .show-pc-content-hasdata {
      left: auto;
      right: -32px;
      width: calc(var(--phone-content-width) + 32px);
      // width: auto;
    }
  }
}
</style>
